module.exports = __webpack_public_path__ + "static/media/rs485_MC1.b260169e.png";